import type { EventHandlerCallback } from "../engines/coreComponents/types";
import type { FSC } from "../engines/renderingEngine/fsc.types";
import {
  BoxNode,
  IconNode,
  TextNode
} from "../engines/renderingEngine/primitiveNodes";
import { PALETTE, THEME } from "./colorPalette.constants";
import { styles } from "./scomponents.styles";

type AddNodeProps = {
  title: string;
  key: string;
  onDropped: EventHandlerCallback;
  onDropping?: EventHandlerCallback;
  onDroppingOut?: EventHandlerCallback;
  onClick: EventHandlerCallback;
  theme?: THEME;
  style?: Parameters<typeof BoxNode>[0]["style"];
  dropTypes?: Parameters<typeof BoxNode>[0]["dropTypes"];
};

export const AddNode: FSC<AddNodeProps> = ({
  key,
  title,
  onDropped,
  onDropping,
  onDroppingOut,
  onClick,
  style = {},
  theme = THEME.LIGHT,
  dropTypes
}) => {
  const themeStyle = styles[theme].addField;
  const palette = PALETTE[theme];

  const addFieldNode = BoxNode({
    key: `${key}`,
    style: style,
    // dragType: "field",
    dropTypes: dropTypes,
    // dragHandleFor: key,
    eventHandlers: {
      onDropped,
      onDropping,
      onDroppingOut
    },
    // onDragStart,
    children: [
      BoxNode({
        key: `${key}-AddContainerWrapper`,
        style: themeStyle.wrapper,
        eventHandlers: {
          onClick
        },
        children: [
          IconNode({
            key: `${key}-Icon`,
            icon: "PlusLight",
            size: 14,
            color: palette.ADD_FIELD_ICON,
            children: []
          }),
          TextNode({
            key: `${key}-Text`,
            text: title,
            textStyle: themeStyle.text,
            style: themeStyle.textContainer,
            children: []
          })
        ]
      })
    ]
  });

  return addFieldNode;
};
